import { StyleSheet } from '@react-pdf/renderer';

import { PDF_STYLES_CONSTANTS } from '../../constants/pdfStylesConstants.ts';

const styles = StyleSheet.create({
  container: {
    paddingTop: PDF_STYLES_CONSTANTS.SPACING.PADDING_TOP_SMALL,
    width: PDF_STYLES_CONSTANTS.DIMENSIONS.CONTENT_WIDTH,
    left: PDF_STYLES_CONSTANTS.DIMENSIONS.LEFT_MARGIN,
    color: PDF_STYLES_CONSTANTS.COLORS.PRIMARY_DARK,
  },
  titleContent: {
    paddingTop: PDF_STYLES_CONSTANTS.SPACING.PADDING_TOP_SMALL,
    paddingBottom: PDF_STYLES_CONSTANTS.SPACING.PADDING_TOP_MEDIUM,
    fontWeight: PDF_STYLES_CONSTANTS.FONT_WEIGHTS.NORMAL,
    fontSize: PDF_STYLES_CONSTANTS.FONT_SIZES.XX_LARGE,
  },
  imageTitle: {
    fontSize: PDF_STYLES_CONSTANTS.FONT_SIZES.MEDIUM,
    marginBottom: 8,
    fontWeight: 'bold',
    textTransform: 'capitalize',
  },
  descriptionImage: {
    width: '100%',
  },
  imageContent: {
    padding: PDF_STYLES_CONSTANTS.SPACING.PADDING_TOP_MEDIUM,
  },
});

export default styles;
